import {StandardModal} from '../ui/standardModal.client';
import {searchClient} from '../algolia/searchClient';
import {StockistsIntro} from './StockistsIntro.client';
import {InstantSearch, Configure} from 'react-instantsearch';
import {StockistsList} from './StockistsList.client';
import CloseButton from '../modals/CloseButton.client';
import {useEffect, useState} from 'react';

type StockistsModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export default function StockistsModal(props: StockistsModalProps) {
  const [coordinates, setCoordinates] = useState('');

  useEffect(() => {
    const getCoordinates = async () => {
      const response = await fetch('/api/get-coordinates');
      const {coordinates: data} = await response.json();
      setCoordinates(data);
    };
    getCoordinates();
  }, []);

  return (
    <InstantSearch
      indexName="stockists"
      searchClient={searchClient}
      future={{
        preserveSharedStateOnUnmount: false,
      }}
    >
      <Configure
        hitsPerPage={1000}
        getRankingInfo={true}
        aroundLatLng={coordinates}
      />
      <StandardModal isOpen={props.isOpen}>
        <div className="flex h-full w-full items-center justify-center bg-black/50">
          <div className="relative h-full  w-full overflow-hidden rounded-md bg-white lg:h-auto lg:max-w-[600px]">
            <CloseButton
              onClick={() => props.setIsOpen(false)}
              variant="dialog"
            />
            <div className="h-fit px-5 pt-15 text-dark-grey lg:px-10 lg:pt-16">
              <StockistsIntro isInModal={true} />
              <StockistsList />
            </div>
          </div>
        </div>
      </StandardModal>
    </InstantSearch>
  );
}
